import {Hero} from '@primer/react-brand'

import type {PrimerComponentHero} from '../../../lib/types/contentful'

export type ContentfulHeroProps = {
  component: PrimerComponentHero

  'data-hpc'?: boolean
}

export function ContentfulHero({component, ...props}: ContentfulHeroProps) {
  return (
    <Hero data-hpc={props['data-hpc']} align={component.fields.align}>
      {component.fields.label && <Hero.Label>{component.fields.label}</Hero.Label>}

      <Hero.Heading>{component.fields.heading}</Hero.Heading>

      {component.fields.description ? <Hero.Description>{component.fields.description}</Hero.Description> : null}

      {component.fields.callToActionPrimary !== undefined && (
        <Hero.PrimaryAction href={component.fields.callToActionPrimary.fields.href}>
          {component.fields.callToActionPrimary.fields.text}
        </Hero.PrimaryAction>
      )}

      {component.fields.callToActionSecondary !== undefined && (
        <Hero.SecondaryAction href={component.fields.callToActionSecondary.fields.href}>
          {component.fields.callToActionSecondary.fields.text}
        </Hero.SecondaryAction>
      )}

      {component.fields.image !== undefined && (
        <Hero.Image
          position={component.fields.imagePosition === 'Inline' ? 'inline-end' : 'block-end'}
          src={component.fields.image.fields.file.url}
          alt={component.fields.image.fields.description || ''}
        />
      )}
    </Hero>
  )
}

try{ ContentfulHero.displayName ||= 'ContentfulHero' } catch {}